const constants = {
  maxCategoryLength: 40,
  categoryEllipsis: ' ...',
  maxCategoryLimit: 6,
  minRecommendationDisplay: 3,
  maxDescriptionLength: 300,
  descriptionEllipsis: ' ...',
  algoliaEventEditions: [],
  eventSource: 'Atlas'
};

export { constants };
